import styled from "styled-components";

export const Container = styled.div<{ isOpen: boolean }>`
  width: 100%;
  height: 3.784375rem;

  background-color: #fff;
  border-radius: 1.1875rem;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);

  .select-filter__label{
    width: 100%;
    height: 3.784375rem;
    padding: 0 2rem;

    position: relative;

    color: var(--blue00);
    line-height: 3.784375rem;
    font-size: 1.4375rem;
    background-color: #fff;
    border-radius: 1.1875rem;
    cursor: pointer;
  }

  .select-filter__arrow-down{
    width: 2rem;
    height: 0.6rem;

    position: absolute;
    top: 45%;
    right: 1rem;
  }

  .select-filter__buttons-wrapper{
    width: 100%;
    ${({ isOpen }) => isOpen ? `
      height: 7,694375rem;
      padding: 0.8rem 2rem;
    `:`
      height: 0;
      padding: 0;
    `}

    margin-top: -0.9rem;

    overflow: hidden;

    display: flex;
    flex-direction: column;
    gap: 0.4rem;

    position: relative;
    z-index: 1;

    background-color: #fff;
    border-radius: 0 0 1.1875rem 1.1875rem;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  }

  .select-filter__button{
    border: 0;
    background-color: transparent;

    color: var(--blue00);

    font-size: 1.4375rem;
    text-align: left;
    cursor: pointer;
  }
`
